import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {CurrentUserResolver} from './resolvers/current-user-resolver';
import {SharedModule} from '../shared/shared.module';
import {AuthGuard} from './guards/auth.guard';
import {RestrictedComponent} from '../../restricted/restricted.component';
import {LoginComponent} from '../../login/login.component';
import {CurrentCustomerResolver} from './resolvers/current-customer-resolver';
import {UnsavedGuard} from './guards/unsaved.guard';
import {ErrorViewComponent} from '../../error-view/error-view.component';
import { MasterGuard } from "./guards/master.guard";

const routes: Routes = [
    {
        path: '',
        canMatch: [
            MasterGuard
        ],
        redirectTo: 'r',
        pathMatch: 'full'
    },
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'login/sso',
        component: LoginComponent,
        canActivate: [
            MasterGuard
        ],
    },
    {
        path: 'r',
        component: RestrictedComponent,
        canActivate: [
            MasterGuard
        ],
        canActivateChild: [
            MasterGuard
        ],
        resolve: [
            CurrentUserResolver,
            CurrentCustomerResolver
        ],
        children: [
            {
                path: 'company-admin',
                loadChildren: () => import('app/modules/company-admin/company-admin.module').then(m => m.CompanyAdminModule)
            },
            {
                path: 'user-admin',
                loadChildren: () => import('app/modules/user-admin/user-admin.module').then(m => m.UserAdminModule)
            },
            {
                path: 'scm-management',
                loadChildren: () => import('app/modules/scm-management/scm-management.module').then(m => m.ScmManagementModule)
            },
            {
                path: 'subscriptions',
                loadChildren: () => import('app/modules/subscriptions/subscriptions.module').then(m => m.SubscriptionsModule)
            },
        ]
    },
    {
        path: '',
        loadChildren: () => import('app/modules/password-management/password-management.module').then(m => m.PasswordManagementModule)
    },
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'error/404'
    },
    {
        path: 'error/:code',
        component: ErrorViewComponent
    }
];

@NgModule({
    imports: [
        SharedModule,
        RouterModule.forRoot(routes)
    ],
    providers: [
        CurrentUserResolver,
        CurrentCustomerResolver,
        AuthGuard,
        UnsavedGuard,
        MasterGuard
    ],
    exports: [RouterModule]
})
export class AccountAdminRoutingModule {}
